import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useMemo } from 'react';
import { Menu } from '../../components/Menu';
import { PlayerButton } from './PlayerButton';
export function CaptionsButton({ tracks, selectedTrackIdx, isOpen, onToggle, onSelectTrack, speechEnabled, speechSupported, onToggleSpeech, onOpenSpeechSettings, }) {
    const triggerRef = useRef(null);
    const items = useMemo(() => {
        const result = [
            {
                type: 'radio',
                id: 'captions-off',
                label: 'Off',
                checked: selectedTrackIdx === -1,
                onClick: () => onSelectTrack(-1),
            },
            ...tracks.map((track, idx) => ({
                type: 'radio',
                id: `caption-track-${track.srclang}-${idx}`,
                label: track.label,
                checked: selectedTrackIdx === idx,
                onClick: () => onSelectTrack(idx),
            })),
        ];
        if (speechSupported) {
            result.push({ type: 'separator', id: 'speech-sep' }, {
                type: 'checkbox',
                id: 'speak-captions',
                label: 'Speak Captions',
                checked: speechEnabled,
                onClick: onToggleSpeech,
            }, {
                type: 'action',
                id: 'speech-settings',
                label: 'Speech Settings…',
                onClick: onOpenSpeechSettings,
            });
        }
        return result;
    }, [tracks, selectedTrackIdx, speechSupported, speechEnabled, onSelectTrack, onToggleSpeech, onOpenSpeechSettings]);
    if (tracks.length === 0)
        return null;
    return (_jsxs("div", { className: "hekate-player-captions-container", children: [_jsx(PlayerButton, { buttonRef: triggerRef, className: `hekate-player-captions-btn ${selectedTrackIdx >= 0 ? 'hekate-player-captions-btn--active' : ''}`, tooltip: "Captions", "aria-haspopup": "menu", "aria-expanded": isOpen, onClick: onToggle }), _jsx(Menu, { items: items, isOpen: isOpen, onClose: onToggle, ariaLabel: "Caption tracks", triggerRef: triggerRef, className: "hekate-player-captions-dropdown" })] }));
}
